import slugify from "slugify"
import React from "react"
import LibrarySubCategory from "./LibrarySubcategory"
import PropTypes from "prop-types"
import { Spacer } from "../atoms/Atoms"
import { HashLink } from "react-router-hash-link"
import { H2Library } from "@carrotfertility/carotene"
import { ContentfulConditionalGate } from "../../../lib/contentful/components/ContentfulConditionGate"

const CategoryNavigation = ({ subCategories, categoryTitle }) => (
  <>
    <div className="dn db-ns">
      <Spacer height={1.125} />
    </div>
    <div className="flex flex-wrap nh25 ph3 ph0-ns mb35 pt2 pt0-ns lh-copy flex-grow mr2-m">
      {subCategories.map((subCategory) => (
        <ContentfulConditionalGate conditions={subCategory.fields.conditions} key={subCategory.fields.navTitle}>
          <HashLink
            className="no-underline black-80 mr2-l f6 subcategory-nav ph25"
            to={`/read/${slugify(categoryTitle)}#${slugify(subCategory.fields.navTitle)}`}
            key={subCategory.fields.navTitle}
          >
            {subCategory.fields.navTitle}
          </HashLink>
        </ContentfulConditionalGate>
      ))}
    </div>
  </>
)

CategoryNavigation.propTypes = {
  subCategories: PropTypes.array.isRequired
}

const LibraryCategoryHeader = ({ categoryTitle }) => (
  <div className="dn db-ns">
    <H2Library>{categoryTitle}</H2Library>
  </div>
)

const LibraryCategory = ({ category }) => {
  const { subCategories } = category.fields
  const hasManySubcategories = subCategories.length > 1
  const categoryTitle = category.fields.navTitle ? category.fields.navTitle : category.fields.title

  return (
    <div className="flex flex-column">
      <LibraryCategoryHeader hasManySubcategories={hasManySubcategories} categoryTitle={categoryTitle} />
      {hasManySubcategories && <CategoryNavigation categoryTitle={categoryTitle} subCategories={subCategories} />}
      {subCategories.map((subCategory) => (
        <div key={subCategory.fields.title} className="mt35-ns mt2">
          <LibrarySubCategory
            categorySlug={slugify(category.fields.title)}
            displayTitle={hasManySubcategories}
            subCategory={subCategory}
          />
        </div>
      ))}
    </div>
  )
}

LibraryCategory.propTypes = {
  category: PropTypes.object.isRequired
}

export default LibraryCategory
